var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 6C2.75 5.31421 3.31421 4.75 4 4.75H20C20.6858 4.75 21.25 5.31421 21.25 6V18C21.25 18.6858 20.6858 19.25 20 19.25H4C3.31421 19.25 2.75 18.6858 2.75 18V6ZM4 3.25C2.48579 3.25 1.25 4.48579 1.25 6V18C1.25 19.5142 2.48579 20.75 4 20.75H20C21.5142 20.75 22.75 19.5142 22.75 18V6C22.75 4.48579 21.5142 3.25 20 3.25H4ZM4.39748 7.3641C4.04623 7.14457 3.58351 7.25135 3.36398 7.6026C3.14445 7.95385 3.25123 8.41657 3.60248 8.6361L11.6025 13.6361C11.8457 13.7881 12.1543 13.7881 12.3975 13.6361L20.3975 8.6361C20.7487 8.41657 20.8555 7.95385 20.636 7.6026C20.4164 7.25135 19.9537 7.14457 19.6025 7.3641L12 12.1157L4.39748 7.3641Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.2f984ca170eea78326c38d592656d4a4.svg";
export { ForwardRef as ReactComponent };